import axios from 'axios'
import qs from 'qs'
import Unile from '@/util'
import { Toast, Indicator } from 'mint-ui'
import config from '../../config/env.js' // baseUrl是小希接口，baseUrl1是学生端接口
import appHybrid from '../util/appHybrid.js'
const { baseUrl, baseUrl1 } = config
const { AppHelper } = appHybrid

function getFromPlatform () {
  var url = location.hash // 获取url中"?"符后的字串
  console.log('url', url)
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(url.indexOf('?') + 1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

// 获取设备Id 平台，1-web,2-android,3-IOS,4-dingtalk --- 顾问端
function getPlatformId () {
  var ua = navigator.userAgent.toLowerCase()
  // console.log('ua', ua)
  if (ua.match(/DingTalk/i) == 'dingtalk') {
    return '4'
  } else if (ua.indexOf('smart-counselor/android') != -1) {
    return '2'
  } else if (ua.indexOf('smart-counselor/ios') != -1) {
    return '3'
  } else {
    return '1'
  }
}

// 获取设备平台 ---- 学生端
function getPlatformForStudent () {
  var urlPlatForm = getFromPlatform().platform
  if (urlPlatForm) {
    return urlPlatForm
  } else {
    var ua = navigator.userAgent.toLowerCase()
    // console.log('ua', ua)
    if (ua.indexOf('smart-counselor/android') != -1) {
      return 'smart-counselor/android'
    } else if (ua.indexOf('smart-counselor/ios') != -1) {
      return 'smart-counselor/ios'
    } else {
      return 'web'
    }
  }
}

// 判断项目来源（学生端、小希）
var platformId
function checkPlatform (url) {
  for (var key in config) {
    if (url.indexOf(config[key]) != -1) {
      if (config[key] === baseUrl1) {
        platformId = getPlatformForStudent()
      } else {
        platformId = getPlatformId()
      }
    }
  }
  // console.log('platformId......ua', platformId)
}
// 获取浏览器信息 1、微信  2、QQ  3、钉钉  4、微博 5、其他
function getBrowserId () {
  var ua = navigator.userAgent.toLowerCase()
  console.log('ua', ua)
  if (ua.match(/DingTalk/i) == 'dingtalk') {
    return '3'
  } else if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return '1'
  } else if (ua.match(/QQ/i) == 'qq') {
    return '2'
  } else if (ua.match(/WeiBo/i) == 'weibo') {
    return '4'
  } else {
    return '5'
  }
}

// 获取token
function getToken () {
  let info = Unile.getLocal.fetch('token')
  return info
}
// 检查是否为分享页面
function checkShare () {
  var url = window.location.href
  if (url.indexOf('/main/home/select-school/choice-result') !== -1) { // 智能选校分享
    return true
  } else if (url.indexOf('/main/my/consultant-details') !== -1) { // 顾问详情分享
    return true
  } else if (url.indexOf('server-detail') !== -1) { // 服务详情分享
    return true
  } else if (url.indexOf('success-case-details') !== -1) { // 成功案例详情分享
    return true
  } else if (url.indexOf('/main/school/school-details') !== -1) { // 院校详情分享
    return true
  } else if (url.indexOf('/main/my/my-article-details') !== -1 || url.indexOf('/main/study/article-details') !== -1) { // 文章详情分享
    return true
  } else if (url.indexOf('/main/study/lesson-detail') !== -1) { // 视频分享
    return true
  } else {
    return false
  }
}
function checkStatus (response, urlStr) {
  Indicator.close()
  // loading
  let errorMsg = ''
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    // 登录失效
    if (response.data.head.code === 9998) {
      if (['2', '3'].indexOf(platformId != -1)) { // 检查是否为 小希移动端
        console.log('current is smart-counselor/app ......')
        errorMsg = 'app登录信息失效'
        console.log(config)
        // 判断是否自动授权
        if (config.autoAuth) {
          setTimeout(() => {
            // 用户登录时调用的接口
            _HttpClient
              .post(baseUrl + `/login/newLogin`, {
                type: 2,
                acount: 13901195015 || 17610273168,
                password: 123456
              })
              .then(res => {
                if (!res) return

                let token = {
                  login: true,
                  memberId: res.body.memberid,
                  token: res.body.token,
                  countryId: res.body.countryId || 12,
                  isSelectCountry: res.body.isSelectCountry
                }
                // this.$local.save("token", token);
                Unile.getLocal.save('token', token)
                console.log('测试环境临时注入localStorage成功', JSON.stringify(token))
                setTimeout(() => {
                  window.location.reload()
                }, 1000)
              })
          }, 5000)
        }
      } else if (checkShare()) { // 检查是否为分享页面
        console.log('token失效 检查是否为分享页面 localStorage.clear()')
        localStorage.clear()
        window.location.reload()
      } else {
        errorMsg = response.data.head.message
        setTimeout(() => {
          console.log('token失效 localStorage.clear()')
          localStorage.clear()
          window.open('/', '_top')
        }, 1000)
      }
    } else if (response.data.head.code === 0) {
      // 检查请求链接 是学生端
      if (urlStr.includes(baseUrl1)) {
        return response.data
      } else {
        if (response.data.body.code === 0) {
          return response.data
        } else if (response.data.body.code === 1020) {
          errorMsg = '密码输入错误，请重新输入'
        } else if (response.data.body.code === 1019) {
          errorMsg = '该账号已注册'
          return response.data
        } else {
          errorMsg = response.data.body.message
        }
      }
    } else if (response.data.head.code === 20002) {
      console.log('20002需要跳转到app登录')
      errorMsg = response.data.head.message
      AppHelper.openLogin()
    } else {
      errorMsg = response.data.head.message
    }
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: errorMsg
  }
}

function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    Toast({
      message: res.msg,
      className: 'toast',
      duration: 1200
    })
    // console.log('msg:', res.msg)
    return undefined
  }
  if (res.data && (!res.data.success)) {
    // console.log(res.data.error_msg)
  }
  return res
}

export const _HttpClient = {
  // _baseUrl: config.baseUrl,
  _token: getToken(),
  /**
   * GET请求
   *
   * @param {string} url URL地址
   * @param {*} [params] 请求参数
   */
  get (url, params = {}, headers = {}) {
    params.timestamp = new Date().getTime()
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    this._token = getToken()
    console.log('_token', this._token)
    // console.log(`_token info >>${qs.stringify(this._token)}`);
    // console.log(`request get baseUrl>>${this._baseUrl + url}?${qs.stringify(params)}`);
    checkPlatform(url)
    console.log('request-url', url)
    console.log('headers', headers)
    return axios({
      method: 'get',
      // baseURL: this._baseUrl,
      url,
      params, // get 请求时带的参数
      timeout: 1000 * 30,
      headers: Object.assign({}, {
        'X-Requested-With': 'XMLHttpRequest',
        // 'memberid': 'G012562',
        // 'token': 'kTsiKx66taxjmwhR',
        // 'platform': 2,
        'memberid': this._token.memberId || '',
        'token': this._token.token || '',
        'platform': platformId,
        'countryId': this._token.countryId || '1',
        'browserId': getBrowserId(),
        'Content-Type': params.ContentType || 'application/x-www-form-urlencoded; charset=UTF-8'
      }, headers || {})
    }).then((res) => {
      return checkStatus(res, url)
    }).then((res) => {
      return checkCode(res)
    }).catch(error => {
      Indicator.close()
      console.log(error)
    })
  },
  /**
   * POST请求
   *
   * @param {string} url URL地址
   * @param {*} [params] 请求参数
   */
  post (url, params = {}) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    this._token = getToken()
    // console.log(`_token info >>${qs.stringify(this._token)}`);
    // console.log(`request post baseUrl>>${this._baseUrl + url}`);
    // console.log(`post params>>${qs.stringify(params)}`);
    checkPlatform(url)
    let data = Object.assign({}, params)
    delete data.headers
    return axios({
      method: 'post',
      // baseURL: this._baseUrl,
      url,
      params: data,
      data: JSON.stringify(data),
      timeout: 1000 * 30,
      headers: Object.assign({
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'memberid': this._token.memberId || '',
        'token': this._token.token || '',
        'platform': platformId || '',
        // 'memberid': 'H9C13G7212HPWGPF',
        // 'token': 'qxgKvn54rg5vYoip',
        // 'platform': 1,
        'countryId': this._token.countryId || '',
        'browserId': getBrowserId() || '',
        'uuid': 'h5',
        'Content-Type': params.ContentType || 'application/x-www-form-urlencoded; charset=UTF-8'
      }, params.headers || {})
    }).then((res) => {
      return checkStatus(res, url)
    }).then((res) => {
      return checkCode(res)
    }).catch(error => {
      Indicator.close()
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/http.client.js